
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("d6Ahp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $6gGPb = parcelRequire("6gGPb");


var $jC4nA = parcelRequire("jC4nA");


var $lSQgn = parcelRequire("lSQgn");


var $t45G9 = parcelRequire("t45G9");


var $7gxpq = parcelRequire("7gxpq");


var $dnhRJ = parcelRequire("dnhRJ");

var $jeQ2h = parcelRequire("jeQ2h");


var $jmjWc = parcelRequire("jmjWc");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3EM6l = parcelRequire("3EM6l");


const $b1fbd1cdbf216579$var$CursorIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "b1Pb5",
    name: "CursorIcon",
    loader: async ()=>(await (parcelRequire("1ryYR"))).CursorIcon
});

const $b1fbd1cdbf216579$var$CursorPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "d5MrK",
    name: "CursorPresenceIcon",
    loader: async ()=>(await (parcelRequire("dIIWs"))).CursorPresenceIcon
});

const $b1fbd1cdbf216579$var$ExternalPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "5eua7",
    name: "ExternalPresenceIcon",
    loader: async ()=>(await (parcelRequire("79Gwb"))).ExternalPresenceIcon
});

const $b1fbd1cdbf216579$var$CanvaPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ggvDj",
    name: "CanvaPresenceIcon",
    loader: async ()=>(await (parcelRequire("h9Vld"))).CanvaPresenceIcon
}); /**
     * The Claude, ChatGPT and Figma brand icons only render for the rare
     * `agentIcon === 'claude'` / `'chatgpt'` / `'figma'` cases, so — like the Cursor icon —
     * they are code-split into their own chunks and loaded after paint rather than weighing
     * down every chunk that includes this module.
     */ 

const $b1fbd1cdbf216579$var$ClaudeIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dxvVm",
    name: "ClaudeIcon",
    loader: async ()=>(await (parcelRequire("i13et"))).ClaudeIcon
}); /**
     * Presence tiles render inside LazyAnalyticsDialog (LAZY). LoadablePaint here
     * crashes the byline dialog: "ClaudePresenceIcon [PAINT] has a higher priority
     * of it's parent component LazyAnalyticsDialog[LAZY]". Match Figma/Lovable and
     * load after paint.
     */ 

const $b1fbd1cdbf216579$var$ClaudePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GVMA6",
    name: "ClaudePresenceIcon",
    loader: async ()=>(await (parcelRequire("kmCSD"))).ClaudePresenceIcon
});

const $b1fbd1cdbf216579$var$ChatGptIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "EXw4a",
    name: "ChatGptIcon",
    loader: async ()=>(await (parcelRequire("5werP"))).ChatGptIcon
});

const $b1fbd1cdbf216579$var$FigmaPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NcBW4",
    name: "FigmaPresenceIcon",
    loader: async ()=>(await (parcelRequire("2o4Bs"))).FigmaPresenceIcon
});

const $b1fbd1cdbf216579$var$LovablePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "hiKXZ",
    name: "LovablePresenceIcon",
    loader: async ()=>(await (parcelRequire("2IHZs"))).LovablePresenceIcon
});

const $b1fbd1cdbf216579$var$ReplitPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BdY0I",
    name: "ReplitPresenceIcon",
    loader: async ()=>(await (parcelRequire("lcZdN"))).ReplitPresenceIcon
});

/**
 * The Dia and Codex icons only render for the rare `agentIcon === 'dia'` / `'codex'`
 * cases, so — like the other brand icons — they are code-split into their own chunks and
 * loaded after paint.
 */ const $b1fbd1cdbf216579$var$DiaIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "00DEF",
    name: "DiaIcon",
    loader: async ()=>(await (parcelRequire("k5k9O"))).DiaIcon
});

const $b1fbd1cdbf216579$var$CodexIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "UYqXM",
    name: "CodexIcon",
    loader: async ()=>(await (parcelRequire("1d3Yv"))).CodexIcon
});

const $b1fbd1cdbf216579$var$CodexPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "stDdE",
    name: "CodexPresenceIcon",
    loader: async ()=>(await (parcelRequire("1G2db"))).CodexPresenceIcon
});

const $b1fbd1cdbf216579$var$RovoPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "i0C6G",
    name: "RovoPresenceIcon",
    loader: async ()=>(await (parcelRequire("c0CFL"))).RovoPresenceIcon
});

const $b1fbd1cdbf216579$var$GrokIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rHk7j",
    name: "GrokIcon",
    loader: async ()=>(await (parcelRequire("j1q6z"))).GrokIcon
});

const $b1fbd1cdbf216579$var$GitHubCopilotIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dP-Du",
    name: "GitHubCopilotIcon",
    loader: async ()=>(await (parcelRequire("60XCe"))).GitHubCopilotIcon
});

const $b1fbd1cdbf216579$var$VisualStudioCodeIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Nlex7",
    name: "VisualStudioCodeIcon",
    loader: async ()=>(await (parcelRequire("56hyP"))).VisualStudioCodeIcon
});

const $b1fbd1cdbf216579$var$OpenCodeIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IBz4P",
    name: "OpenCodeIcon",
    loader: async ()=>(await (parcelRequire("8xiCz"))).OpenCodeIcon
});

const $b1fbd1cdbf216579$var$HermesAgentIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ygIH0",
    name: "HermesAgentIcon",
    loader: async ()=>(await (parcelRequire("kEfEw"))).HermesAgentIcon
});

const $b1fbd1cdbf216579$var$KiroIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GmIrZ",
    name: "KiroIcon",
    loader: async ()=>(await (parcelRequire("752sB"))).KiroIcon
});

const $b1fbd1cdbf216579$var$FirstPartyAgentPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "RlN7s",
    name: "FirstPartyAgentPresenceIcon",
    loader: async ()=>(await (parcelRequire("6Q9J9"))).FirstPartyAgentPresenceIcon
});

const $b1fbd1cdbf216579$var$AmplitudePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "erxfS",
    name: "AmplitudePresenceIcon",
    loader: async ()=>(await (parcelRequire("dWUzC"))).AmplitudePresenceIcon
});

const $b1fbd1cdbf216579$var$ChatGptPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "5Sn5H",
    name: "ChatGptPresenceIcon",
    loader: async ()=>(await (parcelRequire("055n4"))).ChatGptPresenceIcon
});

const $b1fbd1cdbf216579$var$CortexPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "aKhvU",
    name: "CortexPresenceIcon",
    loader: async ()=>(await (parcelRequire("j5D4h"))).CortexPresenceIcon
});

const $b1fbd1cdbf216579$var$DatabricksPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "56vYg",
    name: "DatabricksPresenceIcon",
    loader: async ()=>(await (parcelRequire("1nWYx"))).DatabricksPresenceIcon
});

const $b1fbd1cdbf216579$var$GitHubCopilotPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zvpYp",
    name: "GitHubCopilotPresenceIcon",
    loader: async ()=>(await (parcelRequire("4LPyf"))).GitHubCopilotPresenceIcon
});

const $b1fbd1cdbf216579$var$ManusPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NPozu",
    name: "ManusPresenceIcon",
    loader: async ()=>(await (parcelRequire("eBS61"))).ManusPresenceIcon
});

const $b1fbd1cdbf216579$var$OpenAiPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "E8yL1",
    name: "OpenAiPresenceIcon",
    loader: async ()=>(await (parcelRequire("5DQMY"))).OpenAiPresenceIcon
});

const $b1fbd1cdbf216579$var$SlackPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "shcwR",
    name: "SlackPresenceIcon",
    loader: async ()=>(await (parcelRequire("dhvgg"))).SlackPresenceIcon
});

const $b1fbd1cdbf216579$var$AntigravityPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HAuKS",
    name: "AntigravityPresenceIcon",
    loader: async ()=>(await (parcelRequire("asP6p"))).AntigravityPresenceIcon
});

const $b1fbd1cdbf216579$var$DiaPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "khAwZ",
    name: "DiaPresenceIcon",
    loader: async ()=>(await (parcelRequire("1r0Kk"))).DiaPresenceIcon
});

const $b1fbd1cdbf216579$var$GeminiPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "M9R0Y",
    name: "GeminiPresenceIcon",
    loader: async ()=>(await (parcelRequire("dCjmm"))).GeminiPresenceIcon
});

const $b1fbd1cdbf216579$var$GrokPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3EC9u",
    name: "GrokPresenceIcon",
    loader: async ()=>(await (parcelRequire("hNuBp"))).GrokPresenceIcon
});

const $b1fbd1cdbf216579$var$HermesAgentPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bHfrR",
    name: "HermesAgentPresenceIcon",
    loader: async ()=>(await (parcelRequire("jURii"))).HermesAgentPresenceIcon
});

const $b1fbd1cdbf216579$var$KiroPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g9WFV",
    name: "KiroPresenceIcon",
    loader: async ()=>(await (parcelRequire("mPmb7"))).KiroPresenceIcon
});

const $b1fbd1cdbf216579$var$MicrosoftCopilotPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fPa7_",
    name: "MicrosoftCopilotPresenceIcon",
    loader: async ()=>(await (parcelRequire("e6Wll"))).MicrosoftCopilotPresenceIcon
});

const $b1fbd1cdbf216579$var$VisualStudioCodePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Q1mvx",
    name: "VisualStudioCodePresenceIcon",
    loader: async ()=>(await (parcelRequire("96KjE"))).VisualStudioCodePresenceIcon
});
const $b1fbd1cdbf216579$var$unidentifiedAgentAvatarBackgroundStyles = null;
const $b1fbd1cdbf216579$var$AGENT_AVATAR_CLIP_PATH = 'polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)';
const $b1fbd1cdbf216579$var$styles = {
    xxsmall: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC",
    compactInlineSpacing: "_0GTcwRFQfX _2xTnZxFQfX",
    small: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _0GTcwRFQfX _2xTnZxFQfX",
    medium: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _2xTnZxFQfX",
    iconWrapperSmallNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC",
    iconWrapperMediumNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC",
    unidentifiedAgentAvatarSmall: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _0GTcwRFQfX _2xTnZxFQfX _1uo2ZfTcEg",
    unidentifiedAgentAvatarMedium: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _2xTnZxFQfX _1uo2ZfTcEg",
    unidentifiedAgentAvatarSmallNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _1uo2ZfTcEg",
    unidentifiedAgentAvatarMediumNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _1uo2ZfTcEg",
    brandAgentTile: "_1uo2ZfTcEg _0KLXruDMqu",
    accountAvatarTile: "_1uo2ZfTcEg",
    accountAvatarSurface: "_0KLXrulfZc",
    profileClickableAccountAvatar: "_1VJPcaV97n _0yKXXaDIqT",
    profileClickableAccountAvatarTile: "_1VJPca3VxJ _0yKXXaDIqT",
    presenceGlyphTile: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ",
    avatarOffsetInlineStart: "_1VJPcac8DQ"
};
const $b1fbd1cdbf216579$var$AgentAvatarContainer = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing, children: children } = t0;
    if (avatarSize === "xxsmall") {
        const t1 = hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
        let t2;
        if ($[0] !== t1) {
            t2 = (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, t1);
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== children || $[3] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: t2
            }, children);
            $[2] = children;
            $[3] = t2;
            $[4] = t3;
        } else t3 = $[4];
        return t3;
    }
    if (avatarSize === "medium" && hasInlineSpacing) {
        let t1;
        if ($[5] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.medium
            }, children);
            $[5] = children;
            $[6] = t1;
        } else t1 = $[6];
        return t1;
    }
    if (avatarSize === "medium") {
        let t1;
        if ($[7] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.iconWrapperMediumNoSpacing
            }, children);
            $[7] = children;
            $[8] = t1;
        } else t1 = $[8];
        return t1;
    }
    if (hasInlineSpacing) {
        let t1;
        if ($[9] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.small
            }, children);
            $[9] = children;
            $[10] = t1;
        } else t1 = $[10];
        return t1;
    }
    let t1;
    if ($[11] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b1fbd1cdbf216579$var$styles.iconWrapperSmallNoSpacing
        }, children);
        $[11] = children;
        $[12] = t1;
    } else t1 = $[12];
    return t1;
} : ({ avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing, children: children })=>{
    if (avatarSize === 'xxsmall') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
    }, children);
    if (avatarSize === 'medium' && hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.medium
    }, children);
    if (avatarSize === 'medium') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.iconWrapperMediumNoSpacing
    }, children);
    if (hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.small
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.iconWrapperSmallNoSpacing
    }, children);
};
const $b1fbd1cdbf216579$var$UnidentifiedAgentAvatar = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing } = t0;
    if (avatarSize === "xxsmall") {
        const t1 = hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
        let t2;
        if ($[0] !== t1) {
            t2 = (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, $b1fbd1cdbf216579$var$styles.brandAgentTile, t1);
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
                label: "",
                size: "small",
                color: "var(--ds-icon-subtle, #505258)"
            });
            $[2] = t3;
        } else t3 = $[2];
        let t4;
        if ($[3] !== t2) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: t2
            }, t3);
            $[3] = t2;
            $[4] = t4;
        } else t4 = $[4];
        return t4;
    }
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2yBoao1qiM"
        ]);
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== avatarSize) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
            label: "",
            appearance: "gray",
            size: avatarSize
        });
        $[6] = avatarSize;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== t1 || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "unidentified-agent-avatar-background",
            className: t1
        }, t2);
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    const icon = t3;
    if (avatarSize === "medium" && hasInlineSpacing) {
        let t4;
        if ($[11] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMedium
            }, icon);
            $[11] = icon;
            $[12] = t4;
        } else t4 = $[12];
        return t4;
    }
    if (avatarSize === "medium") {
        let t4;
        if ($[13] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMediumNoSpacing
            }, icon);
            $[13] = icon;
            $[14] = t4;
        } else t4 = $[14];
        return t4;
    }
    if (hasInlineSpacing) {
        let t4;
        if ($[15] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmall
            }, icon);
            $[15] = icon;
            $[16] = t4;
        } else t4 = $[16];
        return t4;
    }
    let t4;
    if ($[17] !== icon) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "unidentified-agent-avatar",
            xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmallNoSpacing
        }, icon);
        $[17] = icon;
        $[18] = t4;
    } else t4 = $[18];
    return t4;
} : ({ avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing })=>{
    if (avatarSize === 'xxsmall') // IconTile starts at 20px; compose the compact 16px hexagon with the native small icon.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, $b1fbd1cdbf216579$var$styles.brandAgentTile, hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    }));
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "unidentified-agent-avatar-background",
        className: (0, $hekY6.default)([
            "_2yBoao1qiM"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
        label: "",
        appearance: "gray",
        size: avatarSize
    }));
    if (avatarSize === 'medium' && hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMedium
    }, icon);
    if (avatarSize === 'medium') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMediumNoSpacing
    }, icon);
    if (hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmall
    }, icon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmallNoSpacing
    }, icon);
}; /**
    * Renders an agent row's leading icon: the fixed AiAgent/Rovo icon for agents that
    * couldn't be resolved to an account, otherwise an ADS Avatar in a hexagon. The
    * feature gate keeps the deprecated AgentAvatar as the fallback during rollout.
    */ 
const $b1fbd1cdbf216579$export$951877a280bbd2e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(306);
    const { name: name, agentIcon: agentIcon, borderColor: providedBorderColor, avatarUrl: avatarUrl, avatarSize: t1, markSize: markSize, isOffsetInlineStart: t2, hasInlineSpacing: t3, fillProfileClickableFrame: t4, colorMode: providedColorMode, usePresenceArtwork: t5, presenceTileFill: presenceTileFill, presenceOutline: presenceOutline } = t0;
    const avatarSize = t1 === undefined ? "small" : t1;
    const isOffsetInlineStart = t2 === undefined ? false : t2;
    const hasInlineSpacing = t3 === undefined ? true : t3;
    const fillProfileClickableFrame = t4 === undefined ? false : t4;
    const usePresenceArtwork = t5 === undefined ? false : t5;
    let isDualAgentAvatarCardEnabled;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        isDualAgentAvatarCardEnabled = false;
        if ((0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) isDualAgentAvatarCardEnabled = true;
        $[0] = isDualAgentAvatarCardEnabled;
    } else isDualAgentAvatarCardEnabled = $[0];
    const observedColorMode = (0, $3EM6l.useAgentAvatarColorMode)();
    const colorMode = providedColorMode ?? (isDualAgentAvatarCardEnabled ? observedColorMode : "light");
    const borderColor = providedBorderColor === undefined && isDualAgentAvatarCardEnabled ? "var(--ds-surface, #FFFFFF)" : providedBorderColor;
    isDualAgentAvatarCardEnabled;
    let t6;
    if ($[1] !== agentIcon || $[2] !== colorMode || $[3] !== presenceOutline) {
        t6 = presenceOutline ?? (isDualAgentAvatarCardEnabled ? (0, $jeQ2h.resolvePresenceOutline)({
            tone: (0, $dnhRJ.getAgentBrandTone)(agentIcon),
            colorMode: colorMode
        }) : undefined);
        $[1] = agentIcon;
        $[2] = colorMode;
        $[3] = presenceOutline;
        $[4] = t6;
    } else t6 = $[4];
    const resolvedPresenceOutline = t6;
    const presenceArtworkEnabled = usePresenceArtwork || isDualAgentAvatarCardEnabled;
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            xxsmall: 16,
            small: 24,
            medium: 32
        };
        $[5] = t7;
    } else t7 = $[5];
    const iconSize = t7[avatarSize];
    const iconMarkSize = markSize ?? iconSize;
    const shouldFillProfileClickableFrame = fillProfileClickableFrame && isDualAgentAvatarCardEnabled;
    let t8;
    if ($[6] !== avatarSize || $[7] !== hasInlineSpacing || $[8] !== resolvedPresenceOutline) {
        t8 = (icon)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                avatarSize: avatarSize,
                hasInlineSpacing: hasInlineSpacing
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.presenceGlyphTile,
                testId: "presence-brand-tile"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7gxpq.PresenceHexOutlineContext).Provider, {
                value: resolvedPresenceOutline
            }, icon)));
        $[6] = avatarSize;
        $[7] = hasInlineSpacing;
        $[8] = resolvedPresenceOutline;
        $[9] = t8;
    } else t8 = $[9];
    const presenceTile = t8;
    let t9;
    bb0: {
        if (agentIcon === "ai-agent" && presenceArtworkEnabled) {
            let t10;
            if ($[10] !== usePresenceArtwork) {
                t10 = !usePresenceArtwork || (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false);
                $[10] = usePresenceArtwork;
                $[11] = t10;
            } else t10 = $[11];
            let t11;
            if ($[12] !== iconSize || $[13] !== providedBorderColor || $[14] !== t10) {
                t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ExternalPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: providedBorderColor,
                    useBorderlessArtwork: t10
                });
                $[12] = iconSize;
                $[13] = providedBorderColor;
                $[14] = t10;
                $[15] = t11;
            } else t11 = $[15];
            let t12;
            if ($[16] !== presenceTile || $[17] !== t11) {
                t12 = presenceTile(t11);
                $[16] = presenceTile;
                $[17] = t11;
                $[18] = t12;
            } else t12 = $[18];
            t9 = t12;
            break bb0;
        }
        if (agentIcon === "ai-agent") {
            let t10;
            if ($[19] !== avatarSize || $[20] !== hasInlineSpacing) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$UnidentifiedAgentAvatar, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                });
                $[19] = avatarSize;
                $[20] = hasInlineSpacing;
                $[21] = t10;
            } else t10 = $[21];
            t9 = t10;
            break bb0;
        }
        if (agentIcon === "rovo" && presenceArtworkEnabled) {
            let t10;
            if ($[22] !== borderColor || $[23] !== colorMode || $[24] !== iconSize || $[25] !== presenceTileFill) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$RovoPresenceIcon, {
                    label: "",
                    size: iconSize,
                    colorMode: colorMode,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[22] = borderColor;
                $[23] = colorMode;
                $[24] = iconSize;
                $[25] = presenceTileFill;
                $[26] = t10;
            } else t10 = $[26];
            let t11;
            if ($[27] !== presenceTile || $[28] !== t10) {
                t11 = presenceTile(t10);
                $[27] = presenceTile;
                $[28] = t10;
                $[29] = t11;
            } else t11 = $[29];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "rovo") {
            let t10;
            if ($[30] !== iconMarkSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $t45G9.RovoIcon), {
                    label: "",
                    size: iconMarkSize
                });
                $[30] = iconMarkSize;
                $[31] = t10;
            } else t10 = $[31];
            let t11;
            if ($[32] !== avatarSize || $[33] !== hasInlineSpacing || $[34] !== t10) {
                t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t10);
                $[32] = avatarSize;
                $[33] = hasInlineSpacing;
                $[34] = t10;
                $[35] = t11;
            } else t11 = $[35];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "cursor" && presenceArtworkEnabled) {
            let t10;
            if ($[36] !== borderColor || $[37] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[36] = borderColor;
                $[37] = iconSize;
                $[38] = t10;
            } else t10 = $[38];
            let t11;
            if ($[39] !== presenceTile || $[40] !== t10) {
                t11 = presenceTile(t10);
                $[39] = presenceTile;
                $[40] = t10;
                $[41] = t11;
            } else t11 = $[41];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "cursor") {
            let t10;
            if ($[42] !== iconMarkSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[42] = iconMarkSize;
                $[43] = t10;
            } else t10 = $[43];
            let t11;
            if ($[44] !== avatarSize || $[45] !== hasInlineSpacing || $[46] !== t10) {
                t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t10);
                $[44] = avatarSize;
                $[45] = hasInlineSpacing;
                $[46] = t10;
                $[47] = t11;
            } else t11 = $[47];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "canva" && presenceArtworkEnabled) {
            let t10;
            if ($[48] !== borderColor || $[49] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CanvaPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[48] = borderColor;
                $[49] = iconSize;
                $[50] = t10;
            } else t10 = $[50];
            let t11;
            if ($[51] !== presenceTile || $[52] !== t10) {
                t11 = presenceTile(t10);
                $[51] = presenceTile;
                $[52] = t10;
                $[53] = t11;
            } else t11 = $[53];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "claude" && presenceArtworkEnabled) {
            let t10;
            if ($[54] !== borderColor || $[55] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[54] = borderColor;
                $[55] = iconSize;
                $[56] = t10;
            } else t10 = $[56];
            let t11;
            if ($[57] !== presenceTile || $[58] !== t10) {
                t11 = presenceTile(t10);
                $[57] = presenceTile;
                $[58] = t10;
                $[59] = t11;
            } else t11 = $[59];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "claude") {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[60] !== t10 || $[61] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11);
                $[60] = t10;
                $[61] = t11;
                $[62] = t12;
            } else t12 = $[62];
            let t13;
            if ($[63] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudeIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[63] = iconMarkSize;
                $[64] = t13;
            } else t13 = $[64];
            let t14;
            if ($[65] !== t12 || $[66] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[65] = t12;
                $[66] = t13;
                $[67] = t14;
            } else t14 = $[67];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "chatgpt" && presenceArtworkEnabled) {
            let t10;
            if ($[68] !== borderColor || $[69] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[68] = borderColor;
                $[69] = iconSize;
                $[70] = t10;
            } else t10 = $[70];
            let t11;
            if ($[71] !== presenceTile || $[72] !== t10) {
                t11 = presenceTile(t10);
                $[71] = presenceTile;
                $[72] = t10;
                $[73] = t11;
            } else t11 = $[73];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "antigravity" && presenceArtworkEnabled) {
            let t10;
            if ($[74] !== borderColor || $[75] !== iconSize || $[76] !== presenceTileFill) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AntigravityPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[74] = borderColor;
                $[75] = iconSize;
                $[76] = presenceTileFill;
                $[77] = t10;
            } else t10 = $[77];
            let t11;
            if ($[78] !== presenceTile || $[79] !== t10) {
                t11 = presenceTile(t10);
                $[78] = presenceTile;
                $[79] = t10;
                $[80] = t11;
            } else t11 = $[80];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "dia" && presenceArtworkEnabled) {
            let t10;
            if ($[81] !== borderColor || $[82] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[81] = borderColor;
                $[82] = iconSize;
                $[83] = t10;
            } else t10 = $[83];
            let t11;
            if ($[84] !== presenceTile || $[85] !== t10) {
                t11 = presenceTile(t10);
                $[84] = presenceTile;
                $[85] = t10;
                $[86] = t11;
            } else t11 = $[86];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "gemini" && presenceArtworkEnabled) {
            let t10;
            if ($[87] !== borderColor || $[88] !== iconSize || $[89] !== presenceTileFill) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GeminiPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[87] = borderColor;
                $[88] = iconSize;
                $[89] = presenceTileFill;
                $[90] = t10;
            } else t10 = $[90];
            let t11;
            if ($[91] !== presenceTile || $[92] !== t10) {
                t11 = presenceTile(t10);
                $[91] = presenceTile;
                $[92] = t10;
                $[93] = t11;
            } else t11 = $[93];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "grok" && presenceArtworkEnabled) {
            let t10;
            if ($[94] !== borderColor || $[95] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[94] = borderColor;
                $[95] = iconSize;
                $[96] = t10;
            } else t10 = $[96];
            let t11;
            if ($[97] !== presenceTile || $[98] !== t10) {
                t11 = presenceTile(t10);
                $[97] = presenceTile;
                $[98] = t10;
                $[99] = t11;
            } else t11 = $[99];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "hermes" && presenceArtworkEnabled) {
            let t10;
            if ($[100] !== borderColor || $[101] !== iconSize || $[102] !== presenceTileFill) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[100] = borderColor;
                $[101] = iconSize;
                $[102] = presenceTileFill;
                $[103] = t10;
            } else t10 = $[103];
            let t11;
            if ($[104] !== presenceTile || $[105] !== t10) {
                t11 = presenceTile(t10);
                $[104] = presenceTile;
                $[105] = t10;
                $[106] = t11;
            } else t11 = $[106];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "kiro" && presenceArtworkEnabled) {
            let t10;
            if ($[107] !== borderColor || $[108] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[107] = borderColor;
                $[108] = iconSize;
                $[109] = t10;
            } else t10 = $[109];
            let t11;
            if ($[110] !== presenceTile || $[111] !== t10) {
                t11 = presenceTile(t10);
                $[110] = presenceTile;
                $[111] = t10;
                $[112] = t11;
            } else t11 = $[112];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "microsoft-copilot" && presenceArtworkEnabled) {
            let t10;
            if ($[113] !== borderColor || $[114] !== iconSize || $[115] !== presenceTileFill) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$MicrosoftCopilotPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[113] = borderColor;
                $[114] = iconSize;
                $[115] = presenceTileFill;
                $[116] = t10;
            } else t10 = $[116];
            let t11;
            if ($[117] !== presenceTile || $[118] !== t10) {
                t11 = presenceTile(t10);
                $[117] = presenceTile;
                $[118] = t10;
                $[119] = t11;
            } else t11 = $[119];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "vscode" && presenceArtworkEnabled) {
            let t10;
            if ($[120] !== borderColor || $[121] !== iconSize || $[122] !== presenceTileFill) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[120] = borderColor;
                $[121] = iconSize;
                $[122] = presenceTileFill;
                $[123] = t10;
            } else t10 = $[123];
            let t11;
            if ($[124] !== presenceTile || $[125] !== t10) {
                t11 = presenceTile(t10);
                $[124] = presenceTile;
                $[125] = t10;
                $[126] = t11;
            } else t11 = $[126];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "chatgpt") {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[127] !== t10 || $[128] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11);
                $[127] = t10;
                $[128] = t11;
                $[129] = t12;
            } else t12 = $[129];
            let t13;
            if ($[130] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[130] = iconMarkSize;
                $[131] = t13;
            } else t13 = $[131];
            let t14;
            if ($[132] !== t12 || $[133] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[132] = t12;
                $[133] = t13;
                $[134] = t14;
            } else t14 = $[134];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "figma" && presenceArtworkEnabled) {
            let t10;
            if ($[135] !== borderColor || $[136] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FigmaPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[135] = borderColor;
                $[136] = iconSize;
                $[137] = t10;
            } else t10 = $[137];
            let t11;
            if ($[138] !== presenceTile || $[139] !== t10) {
                t11 = presenceTile(t10);
                $[138] = presenceTile;
                $[139] = t10;
                $[140] = t11;
            } else t11 = $[140];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "lovable" && presenceArtworkEnabled) {
            let t10;
            if ($[141] !== borderColor || $[142] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$LovablePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[141] = borderColor;
                $[142] = iconSize;
                $[143] = t10;
            } else t10 = $[143];
            let t11;
            if ($[144] !== presenceTile || $[145] !== t10) {
                t11 = presenceTile(t10);
                $[144] = presenceTile;
                $[145] = t10;
                $[146] = t11;
            } else t11 = $[146];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "replit" && presenceArtworkEnabled) {
            let t10;
            if ($[147] !== borderColor || $[148] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ReplitPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[147] = borderColor;
                $[148] = iconSize;
                $[149] = t10;
            } else t10 = $[149];
            let t11;
            if ($[150] !== presenceTile || $[151] !== t10) {
                t11 = presenceTile(t10);
                $[150] = presenceTile;
                $[151] = t10;
                $[152] = t11;
            } else t11 = $[152];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "dia") {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[153] !== t10 || $[154] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[153] = t10;
                $[154] = t11;
                $[155] = t12;
            } else t12 = $[155];
            let t13;
            if ($[156] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[156] = iconMarkSize;
                $[157] = t13;
            } else t13 = $[157];
            let t14;
            if ($[158] !== t12 || $[159] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[158] = t12;
                $[159] = t13;
                $[160] = t14;
            } else t14 = $[160];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "codex" && presenceArtworkEnabled) {
            let t10;
            if ($[161] !== borderColor || $[162] !== colorMode || $[163] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexPresenceIcon, {
                    label: "",
                    size: iconSize,
                    colorMode: colorMode,
                    borderColor: borderColor
                });
                $[161] = borderColor;
                $[162] = colorMode;
                $[163] = iconSize;
                $[164] = t10;
            } else t10 = $[164];
            let t11;
            if ($[165] !== presenceTile || $[166] !== t10) {
                t11 = presenceTile(t10);
                $[165] = presenceTile;
                $[166] = t10;
                $[167] = t11;
            } else t11 = $[167];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "first-party" && presenceArtworkEnabled) {
            let t10;
            if ($[168] !== borderColor || $[169] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FirstPartyAgentPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[168] = borderColor;
                $[169] = iconSize;
                $[170] = t10;
            } else t10 = $[170];
            let t11;
            if ($[171] !== presenceTile || $[172] !== t10) {
                t11 = presenceTile(t10);
                $[171] = presenceTile;
                $[172] = t10;
                $[173] = t11;
            } else t11 = $[173];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "amplitude" && presenceArtworkEnabled) {
            let t10;
            if ($[174] !== borderColor || $[175] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AmplitudePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[174] = borderColor;
                $[175] = iconSize;
                $[176] = t10;
            } else t10 = $[176];
            let t11;
            if ($[177] !== presenceTile || $[178] !== t10) {
                t11 = presenceTile(t10);
                $[177] = presenceTile;
                $[178] = t10;
                $[179] = t11;
            } else t11 = $[179];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "cortex" && presenceArtworkEnabled) {
            let t10;
            if ($[180] !== borderColor || $[181] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CortexPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[180] = borderColor;
                $[181] = iconSize;
                $[182] = t10;
            } else t10 = $[182];
            let t11;
            if ($[183] !== presenceTile || $[184] !== t10) {
                t11 = presenceTile(t10);
                $[183] = presenceTile;
                $[184] = t10;
                $[185] = t11;
            } else t11 = $[185];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "databricks" && presenceArtworkEnabled) {
            let t10;
            if ($[186] !== borderColor || $[187] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DatabricksPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[186] = borderColor;
                $[187] = iconSize;
                $[188] = t10;
            } else t10 = $[188];
            let t11;
            if ($[189] !== presenceTile || $[190] !== t10) {
                t11 = presenceTile(t10);
                $[189] = presenceTile;
                $[190] = t10;
                $[191] = t11;
            } else t11 = $[191];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "github-copilot" && presenceArtworkEnabled) {
            let t10;
            if ($[192] !== borderColor || $[193] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[192] = borderColor;
                $[193] = iconSize;
                $[194] = t10;
            } else t10 = $[194];
            let t11;
            if ($[195] !== presenceTile || $[196] !== t10) {
                t11 = presenceTile(t10);
                $[195] = presenceTile;
                $[196] = t10;
                $[197] = t11;
            } else t11 = $[197];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "manus" && presenceArtworkEnabled) {
            let t10;
            if ($[198] !== borderColor || $[199] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ManusPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[198] = borderColor;
                $[199] = iconSize;
                $[200] = t10;
            } else t10 = $[200];
            let t11;
            if ($[201] !== presenceTile || $[202] !== t10) {
                t11 = presenceTile(t10);
                $[201] = presenceTile;
                $[202] = t10;
                $[203] = t11;
            } else t11 = $[203];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "openai" && presenceArtworkEnabled) {
            let t10;
            if ($[204] !== borderColor || $[205] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenAiPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[204] = borderColor;
                $[205] = iconSize;
                $[206] = t10;
            } else t10 = $[206];
            let t11;
            if ($[207] !== presenceTile || $[208] !== t10) {
                t11 = presenceTile(t10);
                $[207] = presenceTile;
                $[208] = t10;
                $[209] = t11;
            } else t11 = $[209];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "slack" && presenceArtworkEnabled) {
            let t10;
            if ($[210] !== borderColor || $[211] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$SlackPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[210] = borderColor;
                $[211] = iconSize;
                $[212] = t10;
            } else t10 = $[212];
            let t11;
            if ($[213] !== presenceTile || $[214] !== t10) {
                t11 = presenceTile(t10);
                $[213] = presenceTile;
                $[214] = t10;
                $[215] = t11;
            } else t11 = $[215];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "codex") {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[216] !== t10 || $[217] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[216] = t10;
                $[217] = t11;
                $[218] = t12;
            } else t12 = $[218];
            let t13;
            if ($[219] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[219] = iconMarkSize;
                $[220] = t13;
            } else t13 = $[220];
            let t14;
            if ($[221] !== t12 || $[222] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[221] = t12;
                $[222] = t13;
                $[223] = t14;
            } else t14 = $[223];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "grok" && presenceArtworkEnabled) {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[224] !== t10 || $[225] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[224] = t10;
                $[225] = t11;
                $[226] = t12;
            } else t12 = $[226];
            let t13;
            if ($[227] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[227] = iconMarkSize;
                $[228] = t13;
            } else t13 = $[228];
            let t14;
            if ($[229] !== t12 || $[230] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[229] = t12;
                $[230] = t13;
                $[231] = t14;
            } else t14 = $[231];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "github-copilot" && presenceArtworkEnabled) {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[232] !== t10 || $[233] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[232] = t10;
                $[233] = t11;
                $[234] = t12;
            } else t12 = $[234];
            let t13;
            if ($[235] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[235] = iconMarkSize;
                $[236] = t13;
            } else t13 = $[236];
            let t14;
            if ($[237] !== t12 || $[238] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[237] = t12;
                $[238] = t13;
                $[239] = t14;
            } else t14 = $[239];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "vscode" && presenceArtworkEnabled) {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[240] !== t10 || $[241] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[240] = t10;
                $[241] = t11;
                $[242] = t12;
            } else t12 = $[242];
            let t13;
            if ($[243] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodeIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[243] = iconMarkSize;
                $[244] = t13;
            } else t13 = $[244];
            let t14;
            if ($[245] !== t12 || $[246] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[245] = t12;
                $[246] = t13;
                $[247] = t14;
            } else t14 = $[247];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "open-code" && presenceArtworkEnabled) {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[248] !== t10 || $[249] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[248] = t10;
                $[249] = t11;
                $[250] = t12;
            } else t12 = $[250];
            let t13;
            if ($[251] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenCodeIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[251] = iconMarkSize;
                $[252] = t13;
            } else t13 = $[252];
            let t14;
            if ($[253] !== t12 || $[254] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[253] = t12;
                $[254] = t13;
                $[255] = t14;
            } else t14 = $[255];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "hermes" && presenceArtworkEnabled) {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[256] !== t10 || $[257] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[256] = t10;
                $[257] = t11;
                $[258] = t12;
            } else t12 = $[258];
            let t13;
            if ($[259] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[259] = iconMarkSize;
                $[260] = t13;
            } else t13 = $[260];
            let t14;
            if ($[261] !== t12 || $[262] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[261] = t12;
                $[262] = t13;
                $[263] = t14;
            } else t14 = $[263];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "kiro" && presenceArtworkEnabled) {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[264] !== t10 || $[265] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[264] = t10;
                $[265] = t11;
                $[266] = t12;
            } else t12 = $[266];
            let t13;
            if ($[267] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[267] = iconMarkSize;
                $[268] = t13;
            } else t13 = $[268];
            let t14;
            if ($[269] !== t12 || $[270] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[269] = t12;
                $[270] = t13;
                $[271] = t14;
            } else t14 = $[271];
            t9 = t14;
            break bb0;
        }
        const hasDefaultAccountAvatarBorder = providedBorderColor === undefined && isDualAgentAvatarCardEnabled;
        let t10;
        if ($[272] !== avatarSize || $[273] !== avatarUrl || $[274] !== borderColor || $[275] !== hasDefaultAccountAvatarBorder || $[276] !== name) {
            t10 = isDualAgentAvatarCardEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                appearance: "hexagon",
                src: avatarUrl,
                name: name,
                label: "",
                borderColor: borderColor ?? "var(--ds-surface, #FFFFFF)",
                size: avatarSize,
                UNSAFE_isUpdatedGeometry: (0, $9wGTI.fg)("platform-dst-avatar-updated-geometry")
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
                size: avatarSize,
                name: name,
                label: "",
                imageUrl: avatarUrl,
                showBorder: borderColor === undefined && !hasDefaultAccountAvatarBorder,
                UNSAFE_useAdsAvatar: (0, $9wGTI.fg)("platform-dst-avatar-updated-geometry")
            });
            $[272] = avatarSize;
            $[273] = avatarUrl;
            $[274] = borderColor;
            $[275] = hasDefaultAccountAvatarBorder;
            $[276] = name;
            $[277] = t10;
        } else t10 = $[277];
        const accountAvatar = t10;
        if ((0, $9wGTI.fg)("platform-dst-avatar-updated-geometry")) {
            let t11;
            if ($[278] !== accountAvatar || $[279] !== avatarSize || $[280] !== hasInlineSpacing) {
                t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, accountAvatar);
                $[278] = accountAvatar;
                $[279] = avatarSize;
                $[280] = hasInlineSpacing;
                $[281] = t11;
            } else t11 = $[281];
            t9 = t11;
            break bb0;
        }
        let t11;
        if ($[282] !== accountAvatar || $[283] !== shouldFillProfileClickableFrame) {
            t11 = shouldFillProfileClickableFrame ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "profile-clickable-agent-avatar-frame",
                xcss: $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatar
            }, accountAvatar) : accountAvatar;
            $[282] = accountAvatar;
            $[283] = shouldFillProfileClickableFrame;
            $[284] = t11;
        } else t11 = $[284];
        const sizedAccountAvatar = t11;
        if (hasDefaultAccountAvatarBorder) {
            const t12 = shouldFillProfileClickableFrame && $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatarTile;
            let t13;
            if ($[285] !== t12) {
                t13 = (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.accountAvatarTile, $b1fbd1cdbf216579$var$styles.accountAvatarSurface, t12);
                $[285] = t12;
                $[286] = t13;
            } else t13 = $[286];
            let t14;
            if ($[287] !== sizedAccountAvatar || $[288] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t13
                }, sizedAccountAvatar);
                $[287] = sizedAccountAvatar;
                $[288] = t13;
                $[289] = t14;
            } else t14 = $[289];
            let t15;
            if ($[290] !== avatarSize || $[291] !== hasInlineSpacing || $[292] !== t14) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t14);
                $[290] = avatarSize;
                $[291] = hasInlineSpacing;
                $[292] = t14;
                $[293] = t15;
            } else t15 = $[293];
            t9 = t15;
            break bb0;
        }
        let t12;
        if ($[294] !== borderColor || $[295] !== providedBorderColor || $[296] !== shouldFillProfileClickableFrame || $[297] !== sizedAccountAvatar) {
            t12 = borderColor === undefined ? sizedAccountAvatar : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.accountAvatarTile, shouldFillProfileClickableFrame && $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatarTile),
                style: {
                    backgroundColor: providedBorderColor
                }
            }, sizedAccountAvatar);
            $[294] = borderColor;
            $[295] = providedBorderColor;
            $[296] = shouldFillProfileClickableFrame;
            $[297] = sizedAccountAvatar;
            $[298] = t12;
        } else t12 = $[298];
        let t13;
        if ($[299] !== avatarSize || $[300] !== hasInlineSpacing || $[301] !== t12) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                avatarSize: avatarSize,
                hasInlineSpacing: hasInlineSpacing
            }, t12);
            $[299] = avatarSize;
            $[300] = hasInlineSpacing;
            $[301] = t12;
            $[302] = t13;
        } else t13 = $[302];
        t9 = t13;
    }
    const avatar = t9;
    let t10;
    if ($[303] !== avatar || $[304] !== isOffsetInlineStart) {
        t10 = isOffsetInlineStart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-avatar-offset",
            xcss: $b1fbd1cdbf216579$var$styles.avatarOffsetInlineStart
        }, avatar) : avatar;
        $[303] = avatar;
        $[304] = isOffsetInlineStart;
        $[305] = t10;
    } else t10 = $[305];
    return t10;
} : ({ name: name, agentIcon: agentIcon, borderColor: providedBorderColor, avatarUrl: avatarUrl, avatarSize: avatarSize = 'small', markSize: markSize, isOffsetInlineStart: isOffsetInlineStart = false, hasInlineSpacing: hasInlineSpacing = true, fillProfileClickableFrame: fillProfileClickableFrame = false, colorMode: providedColorMode, usePresenceArtwork: usePresenceArtwork = false, presenceTileFill: presenceTileFill, presenceOutline: presenceOutline })=>{
    let isDualAgentAvatarCardEnabled = false;
    if ((0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) isDualAgentAvatarCardEnabled = true;
    const observedColorMode = (0, $3EM6l.useAgentAvatarColorMode)(); // Callers that resolve the color mode themselves, such as the presence face pile, keep priority.
    const colorMode = providedColorMode ?? (isDualAgentAvatarCardEnabled ? observedColorMode : 'light');
    const borderColor = providedBorderColor === undefined && isDualAgentAvatarCardEnabled ? "var(--ds-surface, #FFFFFF)" : providedBorderColor; // Memoized because it becomes a context value, which would otherwise re-render every tile.
    const resolvedPresenceOutline = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>presenceOutline ?? (isDualAgentAvatarCardEnabled ? (0, $jeQ2h.resolvePresenceOutline)({
            tone: (0, $dnhRJ.getAgentBrandTone)(agentIcon),
            colorMode: colorMode
        }) : undefined), [
        presenceOutline,
        isDualAgentAvatarCardEnabled,
        agentIcon,
        colorMode
    ]);
    const presenceArtworkEnabled = usePresenceArtwork || isDualAgentAvatarCardEnabled;
    const iconSize = {
        xxsmall: 16,
        small: 24,
        medium: 32
    }[avatarSize];
    const iconMarkSize = markSize ?? iconSize;
    const shouldFillProfileClickableFrame = fillProfileClickableFrame && isDualAgentAvatarCardEnabled;
    const presenceTile = (icon)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b1fbd1cdbf216579$var$styles.presenceGlyphTile,
            testId: "presence-brand-tile"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7gxpq.PresenceHexOutlineContext).Provider, {
            value: resolvedPresenceOutline
        }, icon)));
    };
    const avatar = (()=>{
        if (agentIcon === 'ai-agent' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ExternalPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: providedBorderColor,
            useBorderlessArtwork: !usePresenceArtwork || (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)
        }));
        if (agentIcon === 'ai-agent') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$UnidentifiedAgentAvatar, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        });
        if (agentIcon === 'rovo' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$RovoPresenceIcon, {
            label: "",
            size: iconSize,
            colorMode: colorMode,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'rovo') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $t45G9.RovoIcon), {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'cursor' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'cursor') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'canva' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CanvaPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'claude' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'claude') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudeIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'chatgpt' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'antigravity' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AntigravityPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'dia' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'gemini' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GeminiPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'grok' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'hermes' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'kiro' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'microsoft-copilot' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$MicrosoftCopilotPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'vscode' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'chatgpt') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'figma' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FigmaPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'lovable' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$LovablePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'replit' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ReplitPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'dia') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'codex' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexPresenceIcon, {
            label: "",
            size: iconSize,
            colorMode: colorMode,
            borderColor: borderColor
        }));
        if (agentIcon === 'first-party' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FirstPartyAgentPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'amplitude' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AmplitudePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'cortex' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CortexPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'databricks' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DatabricksPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'github-copilot' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'manus' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ManusPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'openai' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenAiPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'slack' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$SlackPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'codex') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'grok' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'github-copilot' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'vscode' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodeIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'open-code' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenCodeIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'hermes' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'kiro' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroIcon, {
            label: "",
            size: iconMarkSize
        }));
        const hasDefaultAccountAvatarBorder = providedBorderColor === undefined && isDualAgentAvatarCardEnabled;
        const accountAvatar = isDualAgentAvatarCardEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "hexagon",
            src: avatarUrl,
            name: name,
            label: "",
            borderColor: borderColor ?? "var(--ds-surface, #FFFFFF)",
            size: avatarSize,
            UNSAFE_isUpdatedGeometry: (0, $9wGTI.fg)('platform-dst-avatar-updated-geometry')
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            size: avatarSize,
            name: name,
            label: "",
            imageUrl: avatarUrl,
            showBorder: borderColor === undefined && !hasDefaultAccountAvatarBorder,
            UNSAFE_useAdsAvatar: (0, $9wGTI.fg)('platform-dst-avatar-updated-geometry')
        });
        if ((0, $9wGTI.fg)('platform-dst-avatar-updated-geometry')) // ADS owns the hexagon clip, border, and alignment, so the local clip-path tile cut to the
        // old geometry would shave its corners and the scale corrections would double up.
        // The enlarged hexagon also overflows its nominal box, 25.76px tall at `small`, not 24px.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, accountAvatar);
        const sizedAccountAvatar = shouldFillProfileClickableFrame ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "profile-clickable-agent-avatar-frame",
            xcss: $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatar
        }, accountAvatar) : accountAvatar;
        if (hasDefaultAccountAvatarBorder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.accountAvatarTile, $b1fbd1cdbf216579$var$styles.accountAvatarSurface, shouldFillProfileClickableFrame && $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatarTile)
        }, sizedAccountAvatar));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, borderColor === undefined ? sizedAccountAvatar : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.accountAvatarTile, shouldFillProfileClickableFrame && $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatarTile),
            style: {
                backgroundColor: providedBorderColor
            }
        }, sizedAccountAvatar));
    })();
    return isOffsetInlineStart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-avatar-offset",
        xcss: $b1fbd1cdbf216579$var$styles.avatarOffsetInlineStart
    }, avatar) : avatar;
};
module.exports["AgentRowAvatar"] = $b1fbd1cdbf216579$export$951877a280bbd2e;

});

parcelRegister("t45G9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $af798cdb90e165d5$export$e23ae35269442b4f = ({ label: label = '', size: size = 16 })=>{
    const clipId = (0, $cozmU.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": label ? undefined : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: `url(#${clipId})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0615 20.8951L5.47045 26.4325L3.56007 25.3303C2.43818 24.6835 1.7439 23.4836 1.7439 22.1908V9.82129C1.7439 8.52343 2.4341 7.32872 3.55933 6.68226L11.6173 2.0332C11.5995 2.08338 11.5824 2.13389 11.5662 2.18472C11.4171 2.6476 11.338 3.13666 11.338 3.63654V16.0061C11.338 17.7052 12.2431 19.2725 13.7181 20.1203L15.0615 20.8951Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0615 20.8945L5.47046 26.4319L14.2797 31.5144C15.3815 32.1496 16.7374 32.1609 17.8482 31.5482C17.8683 31.5326 17.8898 31.5182 17.9124 31.5051C18.704 31.0488 19.2828 30.317 19.555 29.4716C19.6657 29.1222 19.7243 28.7529 19.7243 28.3749V23.5835L15.0615 20.8945Z",
        fill: "#6A9A23"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6364 6.66986L26.5817 5.48438L16.9906 11.0218L18.479 11.8801C19.9542 12.7278 20.8587 14.2949 20.8587 15.9942V28.3637C20.8587 28.8643 20.7794 29.354 20.6298 29.8174C20.6138 29.8676 20.597 29.9175 20.5793 29.967L28.6373 25.318C29.7626 24.6715 30.4528 23.4768 30.4528 22.1789V9.80941C30.4528 8.51667 29.7583 7.31666 28.6364 6.66986Z",
        fill: "#AF59E1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.9875 11.0216L12.4691 8.41593V3.62449C12.4691 3.24694 12.5275 2.87812 12.6381 2.52898C12.9098 1.68399 13.4877 0.95247 14.2784 0.495822L14.2808 0.494438C14.3035 0.481361 14.3251 0.466857 14.3452 0.451262C15.456 -0.161474 16.8119 -0.150218 17.9137 0.485033L26.5786 5.48421L16.9875 11.0216Z",
        fill: "#FCA700"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: clipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};
module.exports["RovoIcon"] = $af798cdb90e165d5$export$e23ae35269442b4f;

});

parcelRegister("7gxpq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $06f1794fd21acdfd$export$642f401a307b8452 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $06f1794fd21acdfd$export$685cad5d7f4d1a8c = (size)=>{
    const outline = (0, $cozmU.useContext)($06f1794fd21acdfd$export$642f401a307b8452);
    return outline?.svgHeight ?? size;
};
const $06f1794fd21acdfd$export$82f0d998d3955f1f = ({ d: d, fill: fill, stroke: stroke, strokeWidth: strokeWidth, viewBox: viewBox, size: size, insetStroke: insetStroke = false })=>{
    const outline = (0, $cozmU.useContext)($06f1794fd21acdfd$export$642f401a307b8452);
    const clipPathId = `presence-hex-clip-${(0, $cozmU.useId)()}`;
    if (!outline && insetStroke && stroke && strokeWidth) {
        const insetViewBoxWidth = Number(viewBox.trim().split(/\s+/)[2]);
        const cssPixelScale = Number.isFinite(insetViewBoxWidth) && insetViewBoxWidth > 0 ? insetViewBoxWidth / size : 1;
        // Clipping a doubled stroke to the hexagon leaves only its inner half visible.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: clipPathId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: d
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: d,
            fill: fill
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            "data-presence-layer": "inset-stroke",
            d: d,
            fill: "none",
            stroke: stroke,
            strokeWidth: strokeWidth * cssPixelScale * 2,
            clipPath: `url(#${clipPathId})`
        }));
    }
    if (!outline) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: d,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth
    });
    const viewBoxWidth = Number(viewBox.trim().split(/\s+/)[2]);
    if (!Number.isFinite(viewBoxWidth) || viewBoxWidth <= 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: d,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth
    });
    const toSvgStrokeWidth = (cssPixels)=>cssPixels * viewBoxWidth / size;
    if (outline.width <= 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: d,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth
    }), outline.centerStrokeColor && outline.centerStrokeWidth ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        "data-presence-layer": "center-stroke",
        d: d,
        fill: "none",
        stroke: outline.centerStrokeColor,
        strokeWidth: toSvgStrokeWidth(outline.centerStrokeWidth)
    }) : null);
    const centerStrokeWidth = outline.centerStrokeColor ? outline.centerStrokeWidth ?? 0 : 0;
    // Half the backing stroke is covered by the fill; the center stroke covers another half-width.
    const backingStrokeWidth = toSvgStrokeWidth(outline.width * 2 + centerStrokeWidth);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        "data-presence-layer": "outline",
        d: d,
        fill: stroke,
        stroke: stroke,
        strokeWidth: backingStrokeWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        "data-presence-layer": "fill",
        d: d,
        fill: fill
    }), outline.centerStrokeColor && outline.centerStrokeWidth ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        "data-presence-layer": "center-stroke",
        d: d,
        fill: "none",
        stroke: outline.centerStrokeColor,
        strokeWidth: toSvgStrokeWidth(outline.centerStrokeWidth)
    }) : null);
};
module.exports["PresenceHexOutlineContext"] = $06f1794fd21acdfd$export$642f401a307b8452;
module.exports["usePresenceSvgHeight"] = $06f1794fd21acdfd$export$685cad5d7f4d1a8c;
module.exports["PresenceHexArtwork"] = $06f1794fd21acdfd$export$82f0d998d3955f1f;

});

parcelRegister("dnhRJ", function(module, exports) {
const $b850dfcf5a08d5ec$var$AGENT_BRAND_TONE = {
    chatgpt: 'dark',
    claude: 'neutral',
    codex: 'light',
    cursor: 'dark',
    figma: 'dark',
    lovable: 'dark',
    replit: 'dark',
    rovo: 'adaptive'
};
const $b850dfcf5a08d5ec$export$20ae0a8376081883 = (agentIcon)=>(agentIcon && $b850dfcf5a08d5ec$var$AGENT_BRAND_TONE[agentIcon]) ?? 'neutral';
module.exports["getAgentBrandTone"] = $b850dfcf5a08d5ec$export$20ae0a8376081883;

});

parcelRegister("jeQ2h", function(module, exports) {

var $IQ4Dz = parcelRequire("IQ4Dz");


var $dnhRJ = parcelRequire("dnhRJ");

const $a20a024b40817505$var$FINAL_PRESENCE_HEX_GEOMETRY = {
    24: {
        viewBox: '0 1.3358 24 24',
        hex: 'M22.0557 5.35887L14.06 0.568665C12.7922 -0.190923 11.2087 -0.189455 9.94226 0.572483L1.93793 5.38806C0.735427 6.11151 0 7.41223 0 8.81558V17.8788C0 19.2848 0.738177 20.5876 1.94429 21.3101L9.94429 26.1029C11.2099 26.8611 12.7901 26.8611 14.0557 26.1029L22.0557 21.3101C23.2618 20.5876 24 19.2848 24 17.8788V8.7902C24 7.38421 23.2618 6.08145 22.0557 5.35887Z',
        markOffset: {
            x: -2,
            y: -2.0098
        }
    },
    32: {
        viewBox: '0 0.7639 32 32',
        hex: 'M29.4485 6.81587L18.4537 0.64055C16.9302 -0.215083 15.0707 -0.213413 13.5488 0.644954L2.54367 6.85208C0.972102 7.73848 0 9.40283 0 11.2071V22.3496C0 24.1571 0.975536 25.8239 2.55149 26.709L13.5515 32.8872C15.0721 33.7413 16.9279 33.7413 18.4485 32.8872L29.4485 26.709C31.0245 25.8239 32 24.1571 32 22.3496V11.1753C32 9.3678 31.0245 7.70101 29.4485 6.81587Z',
        markOffset: {
            x: -1.0016,
            y: -1.4473
        }
    }
};
const $a20a024b40817505$var$getFinalPresenceSize = (size)=>{
    if (size > 16 && size <= 24) return 24;
    if (size > 24 && size <= 32) return 32;
    return undefined;
};
const $a20a024b40817505$export$86d5d0060359870e = (size)=>$a20a024b40817505$var$getFinalPresenceSize(size) !== undefined;
const $a20a024b40817505$export$7f633a98e1823142 = (size)=>{
    const finalSize = $a20a024b40817505$var$getFinalPresenceSize(size);
    return finalSize === undefined ? undefined : $a20a024b40817505$var$FINAL_PRESENCE_HEX_GEOMETRY[finalSize];
};
const $a20a024b40817505$export$28ca8990d5adc773 = (art, size)=>{
    const geometry = $a20a024b40817505$export$7f633a98e1823142(size);
    if (!geometry) return art;
    return {
        ...art,
        viewBox: geometry.viewBox,
        hex: geometry.hex,
        ...art.mark ? {
            mark: {
                ...art.mark,
                x: art.mark.x + geometry.markOffset.x,
                y: art.mark.y + geometry.markOffset.y
            }
        } : {}
    };
};
const $a20a024b40817505$export$6909a3e7b7de66da = ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return colorMode === 'dark' ? 'dark' : 'light';
}; /**
    * With the inset border on, an unset or `transparent` border asks for the tile's own border rather
    * than removing it, so callers that suppress the card-colored ring still get the contrast border.
    */ 
const $a20a024b40817505$var$getRequestedBorder = (borderColor)=>borderColor === 'transparent' ? undefined : borderColor; /** Whether the caller asked for no ring of their own, so the tile's own border applies. */ 
const $a20a024b40817505$export$196946f0e26e59cd = (borderColor)=>$a20a024b40817505$var$getRequestedBorder(borderColor) === undefined;
const $a20a024b40817505$export$7d41bd8c4cb42194 = ({ fill: fill, borderIn: borderIn, colorMode: colorMode = 'light', borderColor: borderColor, defaultStrokeWidth: defaultStrokeWidth })=>{
    const tileFill = fill === 'surface' ? "var(--ds-surface, #FFFFFF)" : undefined;
    const requestedBorder = $a20a024b40817505$var$getRequestedBorder(borderColor);
    if (requestedBorder !== undefined) return {
        fill: tileFill,
        stroke: requestedBorder,
        strokeWidth: defaultStrokeWidth
    };
    if (borderIn === 'dark' && colorMode !== 'dark') return {
        fill: tileFill,
        stroke: 'transparent',
        strokeWidth: defaultStrokeWidth
    };
    return {
        fill: tileFill,
        stroke: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
        strokeWidth: 1,
        insetStroke: true
    };
};
/**
 * A tile only loses contrast when its own tone matches the surface behind it, so the center stroke
 * is drawn on light tiles in light mode and dark tiles in dark mode, and never on both. `neutral`
 * tiles hold against either surface, and `adaptive` tiles invert to follow the surface, so neither
 * needs one.
 */ const $a20a024b40817505$var$needsCenterStroke = (tone, colorMode)=>tone === colorMode; /**
                                                                                                                     * The contrast treatment for a presence tile, as a {@link PresenceHexOutline} for
                                                                                                                     * `PresenceHexOutlineContext`.
                                                                                                                     *
                                                                                                                     * `width` is zero because the outer ring is the caller's own `borderColor`; this only contributes
                                                                                                                     * the center stroke.
                                                                                                                     */ 
const $a20a024b40817505$export$52f6e8c3279899c3 = ({ tone: tone, colorMode: colorMode })=>({
        width: 0,
        centerStrokeColor: $a20a024b40817505$var$needsCenterStroke(tone, colorMode) ? "var(--ds-background-accent-gray-subtler, #DDDEE1)" : undefined,
        centerStrokeWidth: 1
    }); // TODO(teab_63_local_agent_borders cleanup): delete this helper; it only serves the gate-off path.
const $a20a024b40817505$export$9e99d98c0acd42bd = ({ size: size, colorMode: colorMode, borderColor: borderColor, defaultBorderColor: defaultBorderColor, defaultStrokeWidth: defaultStrokeWidth })=>{
    if (!$a20a024b40817505$export$86d5d0060359870e(size)) return {
        fill: 'white',
        stroke: borderColor ?? defaultBorderColor,
        strokeWidth: defaultStrokeWidth
    };
    const stroke = borderColor ?? (colorMode === 'light' ? "var(--ds-background-accent-gray-subtler, #DDDEE1)" : undefined);
    return {
        fill: 'white',
        stroke: stroke,
        strokeWidth: stroke === undefined ? undefined : 1
    };
};
module.exports["isFinalPresenceSize"] = $a20a024b40817505$export$86d5d0060359870e;
module.exports["getFinalPresenceHexGeometry"] = $a20a024b40817505$export$7f633a98e1823142;
module.exports["applyFinalPresenceHexGeometry"] = $a20a024b40817505$export$28ca8990d5adc773;
module.exports["usePresenceColorMode"] = $a20a024b40817505$export$6909a3e7b7de66da;
module.exports["isBorderUnset"] = $a20a024b40817505$export$196946f0e26e59cd;
module.exports["getInsetBorderChrome"] = $a20a024b40817505$export$7d41bd8c4cb42194;
module.exports["resolvePresenceOutline"] = $a20a024b40817505$export$52f6e8c3279899c3;
module.exports["getWhiteFillPresenceChrome"] = $a20a024b40817505$export$9e99d98c0acd42bd;

});

parcelRegister("3EM6l", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $4dbee925501a87b6$export$97ecd45ebbe7353 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return colorMode === "dark" ? "dark" : "light";
} : ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return colorMode === 'dark' ? 'dark' : 'light';
};
module.exports["useAgentAvatarColorMode"] = $4dbee925501a87b6$export$97ecd45ebbe7353;

});

parcelRegister("1ryYR", function(module, exports) {

let $10d3727709e09775$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $10d3727709e09775$var$load("3vVgx").then(()=>parcelRequire('hWomQ'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("dIIWs", function(module, exports) {

let $9fd23ef0d8d8fabf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9fd23ef0d8d8fabf$var$load("AvocN").then(()=>parcelRequire('gU8L0'));

});

parcelRegister("79Gwb", function(module, exports) {

let $535a5adfa9fd7614$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $535a5adfa9fd7614$var$load("fsX9p").then(()=>parcelRequire('4WDJq'));

});

parcelRegister("h9Vld", function(module, exports) {

let $c7dfc1b5d43acdb2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7dfc1b5d43acdb2$var$load("7hP3t").then(()=>parcelRequire('gAlam'));

});

parcelRegister("i13et", function(module, exports) {

let $d1dad3e0ddcd3c45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d1dad3e0ddcd3c45$var$load("3vth9").then(()=>parcelRequire('hOYpb'));

});

parcelRegister("kmCSD", function(module, exports) {

let $ed34057fa7fb5bac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed34057fa7fb5bac$var$load("4xQlr").then(()=>parcelRequire('4RcHH'));

});

parcelRegister("5werP", function(module, exports) {

let $404b25f05781b9d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $404b25f05781b9d6$var$load("2gRg3").then(()=>parcelRequire('dBAX8'));

});

parcelRegister("2o4Bs", function(module, exports) {

let $1bd164c40e5cf943$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1bd164c40e5cf943$var$load("3Qa4M").then(()=>parcelRequire('g68r6'));

});

parcelRegister("2IHZs", function(module, exports) {

let $1fb1d05b3852dafc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1fb1d05b3852dafc$var$load("9BDv8").then(()=>parcelRequire('aFLeE'));

});

parcelRegister("lcZdN", function(module, exports) {

let $f70a35417dbd5fdd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f70a35417dbd5fdd$var$load("5zlcp").then(()=>parcelRequire('l0hLa'));

});

parcelRegister("k5k9O", function(module, exports) {

let $e9f3e91a74f68edb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9f3e91a74f68edb$var$load("CwBn2").then(()=>parcelRequire('6g7vS'));

});

parcelRegister("1d3Yv", function(module, exports) {

let $0e1a16b354c55459$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e1a16b354c55459$var$load("2XGiK").then(()=>parcelRequire('3WEjC'));

});

parcelRegister("1G2db", function(module, exports) {

let $138b6dde00315047$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $138b6dde00315047$var$load("iL0Td").then(()=>parcelRequire('a7IdQ'));

});

parcelRegister("c0CFL", function(module, exports) {

let $8be37bb2ddd9e09d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8be37bb2ddd9e09d$var$load("inqXM").then(()=>parcelRequire('2bUT0'));

});

parcelRegister("j1q6z", function(module, exports) {

let $dd925c37417b1dff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dd925c37417b1dff$var$load("7ASbe").then(()=>parcelRequire('6Sqz8'));

});

parcelRegister("60XCe", function(module, exports) {

let $4610fc9d09fd6c9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4610fc9d09fd6c9c$var$load("3RFem").then(()=>parcelRequire('jATtc'));

});

parcelRegister("56hyP", function(module, exports) {

let $3b6b2278ed68af19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3b6b2278ed68af19$var$load("hhlGo").then(()=>parcelRequire('gwIMx'));

});

parcelRegister("8xiCz", function(module, exports) {

let $636fd9904357db9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $636fd9904357db9b$var$load("ekDMC").then(()=>parcelRequire('g8WKc'));

});

parcelRegister("kEfEw", function(module, exports) {

let $f083af58e38f0f83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f083af58e38f0f83$var$load("1qGCp").then(()=>parcelRequire('cs3U4'));

});

parcelRegister("752sB", function(module, exports) {

let $527ae89db7896101$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $527ae89db7896101$var$load("3C2EI").then(()=>parcelRequire('f6xwk'));

});

parcelRegister("6Q9J9", function(module, exports) {

let $4faf250ce6f1f5bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4faf250ce6f1f5bf$var$load("3aCW7").then(()=>parcelRequire('tE3eQ'));

});

parcelRegister("dWUzC", function(module, exports) {

let $a27c9371f1259619$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a27c9371f1259619$var$load("54lzf").then(()=>parcelRequire('aXLjr'));

});

parcelRegister("055n4", function(module, exports) {

let $00f4a2583b1344da$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00f4a2583b1344da$var$load("h5fE5").then(()=>parcelRequire('cJTh1'));

});

parcelRegister("j5D4h", function(module, exports) {

let $de5cca067e6b976c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de5cca067e6b976c$var$load("1YAXz").then(()=>parcelRequire('7TiP7'));

});

parcelRegister("1nWYx", function(module, exports) {

let $1025afb1f092df8e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1025afb1f092df8e$var$load("lgi8F").then(()=>parcelRequire('1DEmL'));

});

parcelRegister("4LPyf", function(module, exports) {

let $37938a430603b2e0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37938a430603b2e0$var$load("6nbpE").then(()=>parcelRequire('bAfpV'));

});

parcelRegister("eBS61", function(module, exports) {

let $aa2e7bc734eccab8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa2e7bc734eccab8$var$load("hebRT").then(()=>parcelRequire('62lYN'));

});

parcelRegister("5DQMY", function(module, exports) {

let $41b98b0cdcb07512$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $41b98b0cdcb07512$var$load("lNk5S").then(()=>parcelRequire('dBtm2'));

});

parcelRegister("dhvgg", function(module, exports) {

let $9ab51cbf6b3410a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9ab51cbf6b3410a0$var$load("gVYrv").then(()=>parcelRequire('cwTyL'));

});

parcelRegister("asP6p", function(module, exports) {

let $79e428c82fd0981c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79e428c82fd0981c$var$load("fkpjl").then(()=>parcelRequire('khv0p'));

});

parcelRegister("1r0Kk", function(module, exports) {

let $10b8e44356859c8f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $10b8e44356859c8f$var$load("1qkVW").then(()=>parcelRequire('dA3QK'));

});

parcelRegister("dCjmm", function(module, exports) {

let $9e9dd765ad3fefb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e9dd765ad3fefb5$var$load("qus56").then(()=>parcelRequire('Hqfh4'));

});

parcelRegister("hNuBp", function(module, exports) {

let $cf4ec045be666d04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf4ec045be666d04$var$load("8JIW0").then(()=>parcelRequire('4xm9S'));

});

parcelRegister("jURii", function(module, exports) {

let $e7fc96615f769463$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e7fc96615f769463$var$load("7LgwE").then(()=>parcelRequire('23Zgt'));

});

parcelRegister("mPmb7", function(module, exports) {

let $0449e49004194b13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0449e49004194b13$var$load("6mdJi").then(()=>parcelRequire('9JUQP'));

});

parcelRegister("e6Wll", function(module, exports) {

let $a45ee200c8c723c8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a45ee200c8c723c8$var$load("8vPRr").then(()=>parcelRequire('hxTG4'));

});

parcelRegister("96KjE", function(module, exports) {

let $6a1899f4cf720fb9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a1899f4cf720fb9$var$load("eVXM2").then(()=>parcelRequire('bO7mD'));

});

parcelRegister("a4kze", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $d4yCt = parcelRequire("d4yCt");

const $6b1a38d2e8ef626f$export$75658d737923c3d1 = (displayName)=>(0, $d4yCt.getAgentBrand)(displayName, {
        includePresenceBrands: (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)
    });
module.exports["getAgentBrand"] = $6b1a38d2e8ef626f$export$75658d737923c3d1;

});

parcelRegister("d4yCt", function(module, exports) {
const $adef0f6cc11fa8bb$var$AGENT_BRANDS = [
    {
        name: 'Claude Code',
        agentIcon: 'claude'
    },
    {
        name: 'Claude',
        agentIcon: 'claude'
    },
    {
        name: 'Codex',
        agentIcon: 'codex'
    },
    {
        name: 'Rovo',
        agentIcon: 'rovo'
    },
    {
        name: 'Cursor',
        agentIcon: 'cursor'
    },
    {
        name: 'ChatGPT',
        agentIcon: 'chatgpt'
    },
    {
        name: 'Dia',
        agentIcon: 'dia'
    }
];
const $adef0f6cc11fa8bb$var$PRESENCE_AGENT_BRANDS = [
    {
        name: '1P',
        agentIcon: 'first-party'
    },
    {
        name: '1P Agent',
        agentIcon: 'first-party'
    },
    {
        name: 'Amplitude',
        agentIcon: 'amplitude'
    },
    {
        name: 'Antigravity',
        agentIcon: 'antigravity'
    },
    {
        name: 'Canva',
        agentIcon: 'canva'
    },
    {
        name: 'Cortex',
        agentIcon: 'cortex'
    },
    {
        name: 'Databricks',
        agentIcon: 'databricks'
    },
    {
        name: 'Figma',
        agentIcon: 'figma'
    },
    {
        name: 'Gemini',
        agentIcon: 'gemini'
    },
    {
        name: 'GitHub Copilot',
        agentIcon: 'github-copilot'
    },
    {
        name: 'Grok',
        agentIcon: 'grok'
    },
    {
        name: 'Hermes Agent',
        agentIcon: 'hermes'
    },
    {
        name: 'Kiro',
        agentIcon: 'kiro'
    },
    {
        name: 'Lovable',
        agentIcon: 'lovable'
    },
    {
        name: 'Manus',
        agentIcon: 'manus'
    },
    {
        name: 'Microsoft Copilot',
        agentIcon: 'microsoft-copilot'
    },
    {
        name: 'OpenAI',
        agentIcon: 'openai'
    },
    {
        name: 'Replit',
        agentIcon: 'replit'
    },
    {
        name: 'Slack',
        agentIcon: 'slack'
    },
    {
        name: 'Visual Studio Code',
        agentIcon: 'vscode'
    },
    {
        name: 'VS Code',
        agentIcon: 'vscode'
    },
    // Deprecated but kept for legacy purposes — some backends still emit these older
    // "<Brand> Agent" account names for Figma, Lovable, and Replit.
    {
        name: 'Figma Agent',
        agentIcon: 'figma'
    },
    {
        name: 'Lovable Agent',
        agentIcon: 'lovable'
    },
    {
        name: 'Replit Agent',
        agentIcon: 'replit'
    }
];
const $adef0f6cc11fa8bb$export$75658d737923c3d1 = (displayName, { includePresenceBrands: includePresenceBrands = false } = {})=>{
    const matches = ({ name: name })=>displayName === name || displayName.startsWith(`${name} (`);
    const brand = $adef0f6cc11fa8bb$var$AGENT_BRANDS.find(matches);
    if (brand) return brand;
    const presenceBrand = $adef0f6cc11fa8bb$var$PRESENCE_AGENT_BRANDS.find(matches);
    if (presenceBrand && includePresenceBrands) return presenceBrand;
    return undefined;
};
module.exports["getAgentBrand"] = $adef0f6cc11fa8bb$export$75658d737923c3d1;

});


//# sourceMappingURL=MediaViewerCommentSidebar.1bd0160f.js.map
